import React from 'react';
import { useNavigate } from 'react-router-dom';

const ButtonBack = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    const lastPath = sessionStorage.getItem('lastVisitedPath');

    sessionStorage.removeItem('lastVisitedPath');

    if (lastPath) {
      navigate(lastPath);
    } else {
      navigate('/old-guidelines');
    }
  };

  return (
    <button
      aria-label="Back"
      type="button"
      id="back-button"
      className="back-button"
      onClick={handleBack}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M5.21875 7.33117H13.3334V8.6645H5.21875L8.79475 12.2405L7.85208 13.1832L2.66675 7.99783L7.85208 2.8125L8.79475 3.75517L5.21875 7.33117Z"
          fill="#2D3748"
        />
      </svg>
    </button>
  );
};

export default ButtonBack;
